/**
 * 数据格式化工具函数
 */

/**
 * 格式化数字，添加千分位分隔符
 * @param {number} value - 需要格式化的数字
 * @return {string} 格式化后的数字字符串
 */
export function formatNumber(value) {
  if (value === null || value === undefined) {
    return '0';
  }

  // 处理大于1000的数字
  if (value >= 1000) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return value.toString();
}

/**
 * 格式化时间为易读格式
 * @param {Date|string|number} time - 时间对象、时间戳或时间字符串
 * @return {string} 格式化后的时间字符串
 */
export function formatTime(time) {
  if (!time) {
    return '未知时间';
  }

  const date = typeof time === 'object' ? time : new Date(time);

  if (isNaN(date.getTime())) {
    return '无效时间';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 格式化日期（不含时间）
 * @param {Date|string|number} date - 日期对象、时间戳或时间字符串
 * @return {string} 格式化后的日期字符串
 */
export function formatDate(date) {
  if (!date) {
    return '未知日期';
  }

  const dateObj = typeof date === 'object' ? date : new Date(date);

  if (isNaN(dateObj.getTime())) {
    return '无效日期';
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * 格式化为相对时间（例如：x分钟前）
 * @param {Date|string|number} time - 时间对象、时间戳或时间字符串
 * @return {string} 相对时间字符串
 */
export function formatRelativeTime(time) {
  if (!time) {
    return '未知时间';
  }

  const date = typeof time === 'object' ? time : new Date(time);

  if (isNaN(date.getTime())) {
    return '无效时间';
  }

  const now = new Date();
  const diff = (now.getTime() - date.getTime()) / 1000; // 转换为秒

  if (diff < 60) {
    return '刚刚';
  } else if (diff < 3600) {
    return Math.floor(diff / 60) + '分钟前';
  } else if (diff < 86400) {
    return Math.floor(diff / 3600) + '小时前';
  } else if (diff < 604800) {
    return Math.floor(diff / 86400) + '天前';
  } else {
    return formatDate(date);
  }
}
